/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-30 11:14:14
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 10:21:26
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  notification,
  Radio,
  Row,
  Switch,
} from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import styles from '../../functionSettingTabs.module.css'
import _ from 'lodash'
import { Checks, Settinglable, Settings } from '../../../../models/setting'
import { getSettingDetail, saveSettingLabel, selectSettings, selectTenant } from '../../../user/setting/settingSlice'
import { PayMethod } from '../../../../models/payment'
import { Tenant } from '../../../../models/tenant'
import { setSettings } from '../../../settings/settingsSlice'

export const PharmacyRetailSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const settings = useSelector(selectSettings)

  const tenant = useSelector(selectTenant)

  const [complaintNumber, setComplaintNumber] = useState('0')

  const [buttonLoading, setButtonLoading] = useState(false)

  useEffect(() => {
    if (props?.selectedTab == '13') {
      dispatch(getSettingDetail())
    }
  }, [props?.selectedTab])

  useEffect(() => {
    if (props?.selectedTab == '13') {
      if (settings) {
        const defaultMethod =
          (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
        dispatch(
          setSettings({
            [Settings.Treatment.DoNotWarnDoctorMismatch]:
              settings[Checks.Gbkdysstx] || false,
            [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
            [Settings.Recipe.ChangePrice]: !(settings[Checks.Gbxgjg] || false),
            [Settings.Payment.DefautMethod]: defaultMethod,
            [Settings.Recipe.AutoChangePrice]: settings[Checks.ZDJSTS] || false,
            [Settings.Recipe.AutoChangePriceAfter]:
              settings[Checks.ZDJSTSBCH] || false,
          })
        )
        const SPJJValue = settings[Checks.SPJJ]
        form.setFieldsValue({
          ...settings,
          [Checks.SPJJ]: SPJJValue || '0'
        })
      }
    }
  }, [settings, props?.selectedTab])
  return (
    <Col className={styles.AISetting}>
      <Form
        form={form}
        onFinish={(values) => {
          const pattern = /^[0-9]*$/

          const t = _.chain(values)
            .omitBy((_, k) => pattern.test(k))
            .value() as Tenant

          const f = _.chain(values)
            .pickBy((_, k) => pattern.test(k))
            .mapValues(
              (v, k) =>
              ({
                type: k,
                value: v?.toString(),
              } as Settinglable)
            )
            .values()
            .value()
          setButtonLoading(true)
          dispatch(
            saveSettingLabel({
              tenant: {
                ...tenant,
                ...t,
              },
              functionList: f,
            })
          )
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: '保存成功,部分配置需要重新登陆后生效',
                duration: 3,
              })
              dispatch(getSettingDetail())
            })
            .catch(() => {
              notification.error({ message: '机构设置保存失败', duration: 3 })
              dispatch(getSettingDetail())
            })
            .finally(() => {
              setButtonLoading(false)
            })
        }}
      >
        <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
          <div style={{ marginTop: '20px' }}>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='商品进价' name={Checks.SPJJ}>
                <Radio.Group value={complaintNumber}
                  onChange={(e) => {
                    setComplaintNumber(e.target.value)
                  }}>
                  <Radio value={'1'}>显示</Radio>
                  <Radio value={'0'}>隐藏</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='药品搜索方式：' name={Checks.YPSSFS}>
                <Radio.Group
                  onChange={(e) => {
                    return
                  }}
                >
                  <Radio value={'1'}>药品名称或追溯码搜索</Radio>
                  <Radio value={'0'}>药品名称或条形码搜索</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='零库存开药'
                name={Checks.Lkcky}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                  onChange={(v: any) => {
                    dispatch(
                      setSettings({
                        [Settings.Recipe.TcmIgnoreStorage]: v,
                        [Settings.Recipe.IgnoreStorage]: v,
                        [Settings.Recipe.TcmUseSpecifiedBatch]: !v,
                        [Settings.Recipe.UseSpecifiedBatch]: !v,
                      })
                    )
                  }}
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，开方搜索范围为商品目录列表，并且不需要发药
              </span>
            </Col>
          </div>
        </div>
        <Row>
          <Col span={12}>
            <Button
              htmlType='button'
              onClick={() => {
                dispatch(getSettingDetail())
              }}
              style={{
                float: 'right',
                marginRight: '10px',
              }}
            >
              取消
            </Button>
          </Col>
          <Col span={12}>
            <Button
              loading={buttonLoading}
              type='primary'
              htmlType='submit'
              style={{
                float: 'left',
              }}
            >
              保存
            </Button>
          </Col>
        </Row>
      </Form>
    </Col >
  )
}
